import { createHttpsCallableHook } from "./createHttpsCallableHook";
import { AddPhoneRequest, AddPhoneResponse } from "@t3/shared";

export const useAddPhone = createHttpsCallableHook<
  AddPhoneRequest,
  AddPhoneResponse
>("addPhone");
